/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */

// Import actionType constants
import {
  STATUS_CLEAN_REQUEST,
  STATUS_FETCH_REQUEST,
  STATUS_FETCH_REQUEST_SUCCESS,
  STATUS_FETCH_REQUEST_FAILURE,
  INDEX_CLIENT_LIST_CLEAN_REQUEST,
  INDEX_CLIENT_LIST_FETCH_REQUEST,
  INDEX_CLIENT_LIST_FETCH_REQUEST_SUCCESS,
  INDEX_CLIENT_LIST_FETCH_REQUEST_FAILURE,
  INDEX_STORE_REQUEST,
  INDEX_STORE_REQUEST_SUCCESS,
  INDEX_STORE_REQUEST_FAILURE,
  STATUS_SUMMARY_FETCH_REQUEST,
  STATUS_SUMMARY_FETCH_REQUEST_SUCCESS,
  STATUS_SUMMARY_FETCH_REQUEST_FAILURE,
  STATUS_YEAR_FETCH_REQUEST,
  STATUS_YEAR_FETCH_REQUEST_SUCCESS,
  STATUS_YEAR_FETCH_REQUEST_FAILURE,
  STATUS_OPTIONS_FETCH_REQUEST,
  STATUS_OPTIONS_FETCH_REQUEST_FAILURE,
  STATUS_OPTIONS_FETCH_REQUEST_SUCCESS,
  EFILE_STATUS_OPTIONS_FETCH_REQUEST,
  EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS,
  EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE,
  CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST,
  CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS,
  CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE,
  EFILE_STATUS_LIST_FETCH_REQUEST,
  EFILE_STATUS_LIST_FETCH_REQUEST_SUCCESS,
  EFILE_STATUS_LIST_FETCH_REQUEST_FAILURE,
  EFILE_STATUS_UPSERT_REQUEST,
  EFILE_STATUS_UPSERT_REQUEST_SUCCESS,
  EFILE_STATUS_UPSERT_REQUEST_FAILURE,
  CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST,
  CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_SUCCESS,
  CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_FAILURE,
  EFILE_STATUS_CLEAN_REQUEST,
  TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST,
  TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_SUCCESS,
  TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_FAILURE,
  CLEAN_TAX_REVIEW_HISTORY_DETAIL,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  listPayload: [],
  listLoading: false,
  listErrors: {},
  listPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  statusSummary: [],
  statusSummaryLoading: false,
  statusSummaryErrors: {},
  statusYearPayload: [],
  statusYearLoading: false,
  statusYearErrors: {},
  statusOptionsPayload: [],
  statusOptionsLoading: false,
  statusOptionsErrors: {},
  efileStatusOptions: [],
  efileStatusOptionsErrors: {},
  efileStatusOptionsLoading: false,
  clientEfileStatusOptions: [],
  clientEfileStatusOptionsErrors: {},
  clientEfileStatusOptionsLoading: false,
  efileStatusList: [],
  efileStatusListErrors: {},
  efileStatusListLoading: false,
  efileStatusListPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  efileUpdate: [],
  efileUpdateErrors: {},
  efileUpdateLoading: false,
  taxRepresentativeOptions: [],
  taxRepresentativeOptionsErrors: {},
  taxRepresentativeOptionsLoading: false,
  taxReviewHistoryDetail: [],
  taxReviewHistoryDetailLoading: false,
  taxReviewHistoryDetailErrors: {},
};

const statusReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case STATUS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    case STATUS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case STATUS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case INDEX_STORE_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case INDEX_STORE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singlePayload: action.data,
        singleLoading: false,
        singleErrors: {},
      });

    case INDEX_STORE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case INDEX_CLIENT_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        listPayload: [],
        listLoading: false,
        listErrors: {},
        listPagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case INDEX_CLIENT_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        listLoading: true,
      });

    case INDEX_CLIENT_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        listPayload: action.data,
        listLoading: false,
        listErrors: {},
        listPagination: {
          current: action.data.currentPage,
          pageSize: 25,
          total: action.data.length,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case INDEX_CLIENT_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        listLoading: false,
        listErrors: action.error,
      });

    case STATUS_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        statusSummaryLoading: true,
      });

    case STATUS_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        statusSummary: action.data,
        statusSummaryLoading: false,
        statusSummaryErrors: {},
      });

    case STATUS_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        statusSummaryLoading: false,
        statusSummaryErrors: action.error,
      });

    case STATUS_YEAR_FETCH_REQUEST:
      return Object.assign({}, state, {
        statusYearLoading: true,
      });

    case STATUS_YEAR_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        statusYearPayload: action.data,
        statusYearLoading: false,
        statusYearErrors: {},
      });

    case STATUS_YEAR_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        statusYearLoading: false,
        statusYearErrors: action.error,
      });

    case STATUS_OPTIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        statusOptionsLoading: true,
      });

    case STATUS_OPTIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        statusOptionsPayload: action.data,
        statusOptionsLoading: false,
        statusOptionsErrors: {},
      });

    case STATUS_OPTIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        statusOptionsLoading: false,
        statusOptionsErrors: action.error,
      });

    case EFILE_STATUS_OPTIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        efileStatusOptionsLoading: true,
      });

    case EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        efileStatusOptions: action.data,
        efileStatusOptionsLoading: false,
        efileStatusOptionsErrors: {},
      });

    case EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        efileStatusOptionsLoading: false,
        efileStatusOptionsErrors: action.error,
      });

    case CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientEfileStatusOptionsLoading: true,
      });

    case CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientEfileStatusOptions: action.data,
        clientEfileStatusOptionsLoading: false,
        clientEfileStatusOptionsErrors: {},
      });

    case CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientEfileStatusOptionsLoading: false,
        clientEfileStatusOptionsErrors: action.error,
      });

    case EFILE_STATUS_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        efileStatusListLoading: true,
      });

    case EFILE_STATUS_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        efileStatusList: action.data,
        efileStatusListLoading: false,
        efileStatusListErrors: {},
        efileStatusListPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case EFILE_STATUS_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        efileStatusListLoading: false,
        efileStatusListErrors: action.error,
      });

    case EFILE_STATUS_UPSERT_REQUEST:
      return Object.assign({}, state, {
        efileUpdateLoading: true,
      });

    case EFILE_STATUS_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        efileUpdate: action.data,
        efileUpdateLoading: false,
        efileUpdateErrors: {},
      });

    case EFILE_STATUS_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        efileUpdateLoading: false,
        efileUpdateErrors: action.error,
      });

    case CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        taxRepresentativeOptionsLoading: true,
      });

    case CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxRepresentativeOptions: action.data,
        taxRepresentativeOptionsLoading: false,
        taxRepresentativeOptionsErrors: {},
      });

    case CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxRepresentativeOptionsLoading: false,
        taxRepresentativeOptionsErrors: action.error,
      });

    case EFILE_STATUS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        efileStatusOptionsErrors: {},
        efileStatusOptionsLoading: false,
        clientEfileStatusOptionsErrors: {},
        clientEfileStatusOptionsLoading: false,
        efileStatusListErrors: {},
        efileStatusListLoading: false,
        efileStatusListPagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        efileUpdate: [],
        efileUpdateErrors: {},
        efileUpdateLoading: false,
        taxRepresentativeOptionsErrors: {},
        taxRepresentativeOptionsLoading: false,
        taxReviewHistoryDetail: [],
        taxReviewHistoryDetailLoading: false,
        taxReviewHistoryDetailErrors: {},
      });

    case TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        taxReviewHistoryDetailLoading: true,
      });

    case TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxReviewHistoryDetail: action.data,
        taxReviewHistoryDetailLoading: false,
        taxReviewHistoryDetailErrors: {},
      });

    case TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxReviewHistoryDetailLoading: false,
        taxReviewHistoryDetailErrors: action.error,
      });

    case CLEAN_TAX_REVIEW_HISTORY_DETAIL:
      return Object.assign({}, state, {
        taxReviewHistoryDetail: [],
        taxReviewHistoryDetailLoading: false,
        taxReviewHistoryDetailErrors: {},
      });
    default:
      return state;
  }
};

export default statusReducer;
